import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-politica-privacidad',
  templateUrl: './politica-privacidad.component.html',
  styleUrls: ['./politica-privacidad.component.css']
})
export class PoliticaPrivacidadComponent implements OnInit {

  loading: boolean;
  ispage: boolean;
  constructor(private router : Router,private location : Location) { }

  ngOnInit(): void {
    this.ispage = this.router.url.includes("politica-privacidad");
    
  }

  goToBack(){
    this.location.back(); // Vuelve a la página anterior
  }
}
